import ViewLearnerPathway from "./viewLearnerPathway";


function ViewLearnerPathways(props) {

  // Define variables
  const headings = props.headings;
  const pathwayData = props.pathwayData;
  const certificateData = props.certificateData;
  const firstName = props.firstName;
  const showResponses = props.showResponses;
  const learnerId = props.learnerId;
  const columns = props.columns;
  const allowExpansion = props.allowExpansion;
  const rowExpansionTemplate = props.rowExpansionTemplate;


  // Screen components
    let certificateElement;
  if( certificateData && certificateData.length > 0 ) {
    certificateElement = (
      <div class='certificates-container'>
        <h3>Certificates</h3>
        {certificateData.map((certificate, index) =>
          <div class='certificate-container' key={`certificate-${index}`}>
            <p class='outfit'>{certificate.name}</p>
            <p>Completed {certificate.issueDate}</p>
            {certificate.fileUrl ? <a href={certificate.fileUrl} target='_blank'>View Certificate</a> : null}
          </div>
        )}
      </div>
    );
  } else {
    certificateElement = (
      <div class='certificates-container'>
        <h3>Certificates</h3>
        <p>{firstName} has not earned any Pathway certificates yet</p>
      </div>
    );
  }

  let blankStateElement;
  if( !pathwayData || pathwayData.length === 0 ) {
    blankStateElement = <p>No Pathways have been started or completed</p>;
    certificateElement = null;
  }


  return (
    <div>

      {blankStateElement}
      {certificateElement}

      {pathwayData.map((pathway, index) =>
        <ViewLearnerPathway
          key={`pathway-${index}`}
          pathway={pathway}
          headings={headings}
          firstName={firstName}
          showResponses={showResponses}
          learnerId={learnerId}
          columns={columns}
          allowExpansion={allowExpansion}
          rowExpansionTemplate={rowExpansionTemplate}
        />
      )}
    </div>
  );
}

export default ViewLearnerPathways;